/* eslint-disable */
import axios, { AxiosResponse } from "axios";
import { ConfigApi } from "./ConfigApi";
import * as CryptoJS from "crypto-js";

class SpaToolsApiClient {
    protected _configApi: ConfigApi;
    private BASE_URL: string = '';
    private xApiKey: string;
    private headers: any;

    constructor(configApi: ConfigApi) {
        this.BASE_URL = configApi.domain;
        this.xApiKey = configApi.xApiKey;
        this._configApi = configApi;
        this.headers = this.getHeaders(configApi.spUserEmail, configApi.xApiKey);
    }

    private randomString = (): string => Math.random().toString(36).slice(-8);

    private formatString = (inputString: string, desiredLength: number, paddingChar: string): string => {
        let formattedString = inputString;
        while (formattedString.length < desiredLength) {
            formattedString += paddingChar;
        }
        return formattedString;
    };

    private getHeaders(email: string, xApiKey: string): any {
        const randomstring = Math.random().toString(36).slice(-8);
        const KEY = this.formatString(xApiKey.replace(/[-:;,._\\@/*&^%$#!()=+]/g, ""), 32, "0");
        const IV = this.formatString(("" + randomstring + "WWRQYHBC2iwkjqq366wfgWQ2qqiWEqD123SDfaAgxk5q1EfBshryYLoedKxjDqw4qqxWKFRf6E" + randomstring + "ZUC5qweq234JU6ozwUVLao").replace(/[-:;,._\\@/*&^%$#!()=+]/g, ""), 16, "0");
        const key = CryptoJS.enc.Utf8.parse(KEY);
        const iv = CryptoJS.enc.Utf8.parse(IV);
        const srcs = CryptoJS.enc.Utf8.parse(xApiKey);
        const encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const srcsE = CryptoJS.enc.Utf8.parse(email);
        const encryptedE = CryptoJS.AES.encrypt(srcsE, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        return {
            "Email": encryptedE.ciphertext.toString(),
            "public-key": encrypted.ciphertext.toString(),
            "www": IV
        };
    }

    public async get(url: string): Promise<AxiosResponse> {
        return await axios({
            method: 'get',
            baseURL: this.BASE_URL,
            url: url,
            headers: this.headers
        });
    }

    public async getLocalhost(url: string): Promise<AxiosResponse> {
        return await axios({
            method: 'get',
            baseURL: 'http://localhost:5005/api/mat/v1/',
            url: url,
            headers: this.getHeader(),
        });
    }

    public async post(url: string, data?: any): Promise<AxiosResponse> {
        const config = {
            method: 'post',
            url: url,
            baseURL: this.BASE_URL,
            headers: this.headers,
            ...(data !== undefined && { data: data }),
        };
        return await axios(config);
    }

    private getHeader = (): Record<string, string> => {

        let randomizing = this.randomString();
        let KEY = this.formatString(
            this._configApi.xApiKey?.replace(/[-:;,._\\@/*&^%$#!()=+]/g, ""),
            32,
            "0"
        );
        let IV = this.formatString(
            `${randomizing}WWRQYHBC2iwkjqq366wfgWQ2qqiWEqD123SDfaAgxk5q1EfBshryYLo${randomizing}edKxjDqw4qqxWKFRf6E${randomizing}ZUC5qweq234JU6ozwUVLao`.replace(
                /[-:;,._\\@/*&^%$#!()=+]/g,
                ""
            ),
            16,
            "0"
        );

        let key = CryptoJS.enc.Utf8.parse(KEY);
        let iv = CryptoJS.enc.Utf8.parse(IV);

        let encrypted;

        let srcs = CryptoJS.enc.Utf8.parse(this._configApi.xApiKey);
        encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        let encryptedE;

        let srcsE = CryptoJS.enc.Utf8.parse(
            this.checkEmail(this._configApi.spUserEmail)
        );

        encryptedE = CryptoJS.AES.encrypt(srcsE, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        return {
            "public-key": encrypted.ciphertext.toString(),
            www: IV,
            Email: encryptedE.ciphertext.toString()
        };
    };

    private checkEmail = (str: string): string => {
        const validEmails: string[] = [
            "ven.pasynsoftdev4@associatedasset.com",
            "ven.pasynsoftdev2@associatedasset.com",
            "tmctesterson@aamaz.com",
            "nzolotukhin@pasynsoft.com",
        ];

        return validEmails.includes(str) ? "tnpatterson@associatedasset.com" : str;
    };
}

export default SpaToolsApiClient